module.exports = __webpack_public_path__ + "static/media/page-flip-6.e5313ece.mp3";